import type { HTMLAttributes } from 'react'

import styles from './Tabs.module.css'

export interface TabItem<Key extends string> {
  key: Key
  label: string
  count?: number
}

export interface TabsProps<Key extends string> extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  items: Array<TabItem<Key>>
  value: Key
  onChange: (value: Key) => void
}

export function Tabs<Key extends string>({ items, value, onChange, className = '', ...props }: TabsProps<Key>) {
  return (
    <div className={`${styles.tabs} ${className}`} role="tablist" {...props}>
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          role="tab"
          aria-selected={item.key === value}
          className={`${styles.tab} ${item.key === value ? styles.active : ''}`}
          onClick={() => onChange(item.key)}
        >
          {item.label}
          {item.count === undefined ? null : <span className={styles.count}>{item.count}</span>}
        </button>
      ))}
    </div>
  )
}
